import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _inherits from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import LoginBase from "./LoginBase";

var LoginProxy = /*#__PURE__*/function (_LoginBase) {
  _inherits(LoginProxy, _LoginBase);

  var _super = _createSuper(LoginProxy);

  function LoginProxy(login) {
    var _this;

    _classCallCheck(this, LoginProxy);

    _this = _super.call(this);
    _this._login = login;
    _this.VERSION = login.VERSION;
    return _this;
  }

  _createClass(LoginProxy, [{
    key: "setConfig",
    value: function setConfig() {
      var _this$_login;

      return (_this$_login = this._login).setConfig.apply(_this$_login, arguments);
    }
  }, {
    key: "init",
    value: function init() {
      var _this$_login2;

      return (_this$_login2 = this._login).init.apply(_this$_login2, arguments);
    }
  }, {
    key: "onInit",
    value: function onInit() {
      var _this$_login3;

      return (_this$_login3 = this._login).onInit.apply(_this$_login3, arguments);
    }
  }, {
    key: "loginType",
    value: function loginType() {
      var _this$_login4;

      return (_this$_login4 = this._login).loginType.apply(_this$_login4, arguments);
    }
  }, {
    key: "isLogin",
    value: function isLogin() {
      var _this$_login5;

      return (_this$_login5 = this._login).isLogin.apply(_this$_login5, arguments);
    }
  }, {
    key: "isStrictLogin",
    value: function isStrictLogin() {
      var _this$_login6;

      return (_this$_login6 = this._login).isStrictLogin.apply(_this$_login6, arguments);
    }
  }, {
    key: "isPTLogin",
    value: function isPTLogin() {
      var _this$_login7;

      return (_this$_login7 = this._login).isPTLogin.apply(_this$_login7, arguments);
    }
  }, {
    key: "isQQLogin",
    value: function isQQLogin() {
      var _this$_login8;

      return (_this$_login8 = this._login).isQQLogin.apply(_this$_login8, arguments);
    }
  }, {
    key: "isNewQQLogin",
    value: function isNewQQLogin() {
      var _this$_login9;

      return (_this$_login9 = this._login).isNewQQLogin.apply(_this$_login9, arguments);
    }
  }, {
    key: "isWXLogin",
    value: function isWXLogin() {
      var _this$_login10;

      return (_this$_login10 = this._login).isWXLogin.apply(_this$_login10, arguments);
    }
  }, {
    key: "openLogin",
    value: function openLogin() {
      var _this$_login11;

      return (_this$_login11 = this._login).openLogin.apply(_this$_login11, arguments);
    }
  }, {
    key: "logout",
    value: function logout() {
      var _this$_login12;

      return (_this$_login12 = this._login).logout.apply(_this$_login12, arguments);
    }
  }, {
    key: "checkUser",
    value: function checkUser() {
      var _this$_login13;

      return (_this$_login13 = this._login).checkUser.apply(_this$_login13, arguments);
    }
  }, {
    key: "getMainUserInfo",
    value: function getMainUserInfo() {
      var _this$_login14;

      return (_this$_login14 = this._login).getMainUserInfo.apply(_this$_login14, arguments);
    }
  }, {
    key: "getMainCookie",
    value: function getMainCookie() {
      var _this$_login15;

      return (_this$_login15 = this._login).getMainCookie.apply(_this$_login15, arguments);
    }
  }, {
    key: "getUin",
    value: function getUin() {
      var _this$_login16;

      return (_this$_login16 = this._login).getUin.apply(_this$_login16, arguments);
    }
  }, {
    key: "getUid",
    value: function getUid() {
      var _this$_login17;

      return (_this$_login17 = this._login).getUid.apply(_this$_login17, arguments);
    }
  }, {
    key: "getVuid",
    value: function getVuid() {
      var _this$_login18;

      return (_this$_login18 = this._login).getVuid.apply(_this$_login18, arguments);
    }
  }, {
    key: "getToken",
    value: function getToken() {
      var _this$_login19;

      return (_this$_login19 = this._login).getToken.apply(_this$_login19, arguments);
    }
  }, {
    key: "loginSource",
    value: function loginSource() {
      var _this$_login20;

      return (_this$_login20 = this._login).loginSource.apply(_this$_login20, arguments);
    }
  }, {
    key: "setLogin",
    value: function setLogin(login) {
      this._login = login;
    }
  }, {
    key: "openNativeLogin",
    value: function openNativeLogin() {
      return this._login.openNativeLogin();
    }
  }]);

  return LoginProxy;
}(LoginBase);

export { LoginProxy as default };